<div class="placeholderDs__cont placeholderDs__cont--{{type}}" [ngStyle]="{ width: useMeasurements(width) ? width : 'auto' , height: useMeasurements(height) ? height : 'auto'  }">
  <ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="placeholderType.Secondary">
      <div class="placeholderDs__cont--secondary-row-1">
        <ng-container *ngTemplateOutlet="placeholder; context: { w: '100%', h: '180px' }"></ng-container>
      </div>
      <div class="placeholderDs__cont--secondary-row-2">
        <ng-container *ngTemplateOutlet="placeholder; context: { w: '60%', h: '25px' }"></ng-container>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="placeholderType.Tertiary">
      <div class="placeholderDs__cont--tertiary-col-1">
        <ng-container *ngTemplateOutlet="placeholder; context: { w: '210px', h: '180px' }"></ng-container>
      </div>
      <div class="placeholderDs__cont--tertiary-col-2">
        <div class="placeholderDs__cont--tertiary-row-1">
          <ng-container *ngTemplateOutlet="placeholder; context: { w: '100%', h: '16px' }"></ng-container>
        </div>
        <div class="placeholderDs__cont--tertiary-row-2">
          <ng-container *ngTemplateOutlet="placeholder; context: { w: '60%', h: '16px' }"></ng-container>
        </div>
        <div class="placeholderDs__cont--tertiary-row-3">
          <ng-container *ngTemplateOutlet="placeholder; context: { w: '60%', h: '16px' }"></ng-container>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="placeholderType.Quaternary">
      <div class="placeholderDs__cont--quaternary-td-1">
        <div class="placeholderDs__cont--quaternary-col-1">
          <div class="placeholderDs__cont--quaternary-row-1">
            <ng-container *ngTemplateOutlet="placeholder; context: { w: '100%', h: '16px' }"></ng-container>
          </div>
          <div class="placeholderDs__cont--quaternary-row-2">
            <ng-container *ngTemplateOutlet="placeholder; context: { w: '100%', h: '16px' }"></ng-container>
          </div>
          <div class="placeholderDs__cont--quaternary-row-3">
            <ng-container *ngTemplateOutlet="placeholder; context: { w: '100%', h: '16px' }"></ng-container>
          </div>
        </div>
        <div class="placeholderDs__cont--quaternary-col-2">
          <div class="placeholderDs__cont--quaternary-row-1">
            <ng-container *ngTemplateOutlet="placeholder; context: { w: '100%', h: '16px' }"></ng-container>
          </div>
          <div class="placeholderDs__cont--quaternary-row-2">
            <ng-container *ngTemplateOutlet="placeholder; context: { w: '100%', h: '16px' }"></ng-container>
          </div>
          <div class="placeholderDs__cont--quaternary-row-3">
            <ng-container *ngTemplateOutlet="placeholder; context: { w: '100%', h: '16px' }"></ng-container>
          </div>
        </div>
      </div>
      <div class="placeholderDs__cont--quaternary-td-2">
        <div class="placeholderDs__cont--quaternary-rowspan-1">
          <ng-container *ngTemplateOutlet="placeholder; context: { w: '100%', h: '16px' }"></ng-container>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <ng-container *ngTemplateOutlet="placeholder; context: { w: width, h: height }"></ng-container>
    </ng-container>
  </ng-container>
</div>

<ng-template #placeholder let-w="w" let-h="h">
  <div class="placeholderDs__skeleton" [ngStyle]="{ width: w ? w : defaultDimension, height: h ? h : defaultDimension }">
    <div class="placeholderDs__animated"></div>
  </div>
</ng-template>